// extracted by mini-css-extract-plugin
export default {"questions":"ShopQuestions_questions__7d8nT","contact":"ShopQuestions_contact__Vlmv9"};